import { useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import { useDeleteBiochemicalPlan } from 'hooks/patient.hook';

import Button from '../../Button/Button.component';

const DeleteBiochemicalPlanForm = () => {
  const { id } = useSelector(
    state => state.patient.profile.biochemicalPlanSelected,
  );

  const { mutate } = useDeleteBiochemicalPlan();

  const onConfirmHandler = () => {
    mutate(id);
  };

  return (
    <Box>
      <Typography>
        ¿Confirmas que deseas eliminar este análisis clínico?
      </Typography>
      <Typography>No podrás deshacer esta acción</Typography>
      <Box mt={2} textAlign="center">
        <Button variant="contained" color="primary" onClick={onConfirmHandler}>
          Confirmar
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteBiochemicalPlanForm;
